import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Main2022() {
   const handleDownload1 = () => {
    window.open("assets/2022/PL Ramliana.pdf", "_blank");
  };
  const handleDownload2 = () => {
    window.open("assets/2022/Tuanmuansanga & James LT Thanga.pdf", "_blank");
  };
  const handleDownload3 = () => {
    window.open(
      "assets/2022/K Vanrammawia & Lalmalsawma Khiangte.pdf",
      "_blank",
    );
  };
   const handleDownload4 = () => {
    window.open("assets/2022/Lalrinkima & Lalhriatpuii.pdf", "_blank");
  };
  const handleDownload5 = () => {
    window.open("assets/2022/KT Buansing & Lalhriatpuii.pdf", "_blank");
  };
  const handleDownload6 = () => {
    window.open("assets/2022/Lalsangzuala Khiangte.pdf", "_blank");
  };
  const handleDownload7 = () => {
    window.open("assets/2022/Lalzuiliana & Jacob MS Dawngliana.pdf", "_blank");
  }; 
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className=" h-full justify-center items-center flex mx-20">
        <div className="flex flex-col-reverse lg:flex-row  justify-center items-center">
          {/* Book Cover */}
          <div className=" mr-20 sm:mt-0 md:mt-20 mt-20 flex flex-col justify-center items-center">
            <img className="h-96 w-60" src="mea.webp" />
            <div className=" text-center font-semibold">ISSN 2581-7523</div>
          </div>
          {/* Main Page */}
          <div className="">
            <div className="">
              <div className=" font-bold text-xl">Mizoram Economic Review</div>
              <div className="text-sm">Volume 5, No. 1&2 (2022)</div>
              <div className="text-sm">ISSN 2581-7523</div>
            </div>

            {/* Content */}
            <div className="mt-10 grid grid-row-1 gap-6">
              <button className="text-left" onClick={handleDownload1}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Treatment of Causes and Classifications of Poverty: An
                  Essential Tool for Socio-Economic Development Policy
                </div>
                <div className="text-sm text-green-600">P.L.Ramliana</div>
              </button>
              <button className="text-left" onClick={handleDownload2}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Urban Housing and Basic Amenities in North-East India
                </div>
                <div className="text-sm text-green-600">
                  Tuanmuansanga & James LT Thanga
                </div>
              </button>
              <button className="text-left" onClick={handleDownload3}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Economics of Production and Marketing of Cabbage in Samthang
                  Village, Champhai District of Mizoram
                </div>
                <div className="text-sm text-green-600">
                  K.Vanrammawia & Lalmalsawma Khiangte
                </div>
              </button>
              <button className="text-left" onClick={handleDownload4}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Recent trends in Efficiency and Productivity of Public
                  Hospitals in Mizoram
                </div>
                <div className="text-sm text-green-600">
                  Lalrinkima & Lalhriatpuii
                </div>
              </button>
              <button className="text-left" onClick={handleDownload5}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Performance Analysis of Select Banks in Mizoram
                </div>
                <div className="text-sm text-green-600">
                  K.T Buansing & Lalhriatpuii
                </div>
              </button>
              <button className="text-left" onClick={handleDownload6}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Knowledge, Aptitude and Practices in Four Selected Districts
                  in Mizoram Lok Sabha Parliamentary Constituency Elections,
                  2019: A Reflections
                </div>
                <div className="text-sm text-green-600">
                  Lalsangzuala Khiangte
                </div>
              </button>
              <button className="text-left" onClick={handleDownload7}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Use of Electronic Resources and Services in Libraries: An
                  Analogous Analysis of Pachhunga University College, Govt.
                  Hrangbana College and Govt. T. Romana College
                </div>
                <div className="text-sm text-green-600">
                  Lalzuiliana & Jacob MS Dawngliana
                </div>
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
